import { render, staticRenderFns } from "./PaniereProductPurchaseDialog.vue?vue&type=template&id=53003675&scoped=true"
import script from "./PaniereProductPurchaseDialog.vue?vue&type=script&lang=js"
export * from "./PaniereProductPurchaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53003675",
  null
  
)

export default component.exports